import {combineReducers} from 'redux';
import Position from './Position/Module';
import Personnel from './Personnel/Module';
import Common from './Common/Module';

const reducers = combineReducers({
  Position,
  Personnel,
  Common,
});

export default reducers;
